var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AttachedTrait } from '../attachedtrait/AttachedTrait';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { ContentEdit } from './modules/ContentEdit';
import { ContentInfo } from './modules/ContentInfo';
import { ContentTags } from './modules/ContentTags';
export class AttachedContent extends AttachedTrait {
    get contentEdit() {
        return new ContentEdit(this);
    }
    get contentInfo() {
        return new ContentInfo(this);
    }
    get contentTags() {
        return new ContentTags(this);
    }
    get itemNumber() {
        return this.contentInfo.contentNumber;
    }
    get autoTags() {
        return [...this.contentTags.autoTags, ...super.autoTags];
    }
    static get stripInfo() {
        return {
            extends: AttachedTrait.stripInfo,
            props: {}
        };
    }
}
__decorate([
    memoize
], AttachedContent.prototype, "contentEdit", null);
__decorate([
    memoize
], AttachedContent.prototype, "contentInfo", null);
__decorate([
    memoize
], AttachedContent.prototype, "contentTags", null);
__decorate([
    memoize
], AttachedContent, "stripInfo", null);
